<template lang="pug">
.p_modal-inner.c_col-c
    .p_modal-body
      .c_inner(v-if="$store.state.gallery.length > 0")
        .p_modal-image
          .p_modal-image-inner
            button.p_modal-close(v-touch:tap="tap", @click.native="closeTheModal")
              .p_modal-close-btn
                .p_modal-close-btn-inner
                  span.-bar1
                  span.-bar2
            .-current(ref="current")
              img(:src="getImage('/top/gallery', '/img' + id + '.jpg', '')")
            .p_pagenavi
              button.p_pagenavi-btn-prev.p_pagenavi-btn(@click.stop="clickThePagenavi('prev')")
                i.-arr: span.prev.u_rotate-45-l
              button.p_pagenavi-btn-next.p_pagenavi-btn(@click.stop="clickThePagenavi('next')")
                i.-arr: span.next.u_rotate-45-r

          .p_modal-body-inner(v-if="items[id]", ref="currentBody")
            .p_modal-body-header
              p.p_modal-body-heading.c_col.u_col-ai-c(v-html="items[id].heading")
            .p_modal-body-text: p(v-html="items[id].text")
</template>

<script>
  export default {
    props: {
      array: Array,
    },
    data () {
      return {
        id: Number,
        speed: .3,
        items: {}
      }
    },
    watch: {
      '$route.query': function () {
        let query = this.$route.query
        let refs = this.$refs
        let current = [ refs.current, refs.currentBody ]
        let speed = this.speed
        let tl = new TimelineMax()
        this.id = this.getCurrentId()

        if (query.modal) {
          this.$store.commit('MODAL_SHOW', true)
          tl.to(current, speed, { opacity: 0 })
            .to(current, speed, { opacity: 1 })
        }
      }
    },
    mounted () {
      let query = this.$route.query
      let refs = this.$refs
      let current = [ refs.current, refs.currentBody ]
      this.id = this.getCurrentId()

      if (query.modal) {
        this.$store.commit('MODAL_SHOW', true)
        TweenMax.to(current, .6, { opacity: 1 })
      }
      this.items = this.$store.state.gallery.items
    },
    methods: {
      getCurrentId () {
        return Number(this.$route.query.id)
      },
      clickThePagenavi (direction) {
        let _self = this
        let array = this.array
        let refs = this.$refs
        let current = [ refs.current, refs.currentBody ]
        let id = (direction == 'prev') ? array[array.length - 1] : array[1]
        let speed = this.speed

        TweenMax.to(current, speed, { opacity: 0,
          onComplete () {
            _self.$router.push({
              query: {
                id: id,
                modal: true,
              },
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.p_modal {
  &-inner {
    margin: auto;
    padding: rem(100) 0;
    position: absolute;
    width: 100%;
    min-height: 100%;
    left: 0;
    right: 0;
    top: 0;
  }

  &-body {
    width: 100%;
    margin: 0 auto;
    padding: rem(50) 0;
    position: relative;

    &-inner {
      @include sp {
        padding: rem(56,2) 0 0;
      }
      @include pc {
        padding: rem(38) 0 0;
      }
    }

    &-header {
      @include sp {
      }
      margin: 0 0 rem(15);
    }

    &-heading {
      @include sp {
        font-size: rem(56,2);
        min-height: (132/28) * 1em;
      }
      @include pc {
        font-size: rem(32);
      }
      font-weight: bold;
    }

    &-text {
      @include sp {
        min-height: 12em;
      }
      @include pc {
        font-size: rem(18);
        min-height: (102/18)*1em;
      }

      p {
        line-height: (56/28);
      }
    }
  }

  &-image {
    &-inner {
      position: relative;
      line-height: 0;

      .-current {
        width: 100%;
        height: 0;
        padding: 0 0 cal(1120,1920);
        position: relative;
        opacity: 0;
        line-height: 0;
        overflow: hidden;
        display: block;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          margin: auto;
          display: block;
        }
      }
    }
  }

  &-close {
    @include pc {
      top: rem(-60 + -30);
    }
    @include sp {
      top: rem(-60 + -15);
    }
    right: rem(0);
    width: 60px;
    height: 60px;
    position: absolute;
    z-index: 999;

    &-btn {
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      position: absolute;

      &:hover {
        @include pc {
          cursor: pointer;
        }
      }

      &-inner {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: block;
        transform: rotate(45deg);
      }

      .-bar {
        &1 {
          width: 100%;
          height: 2px;
          background: #000;
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
        }
        &2 {
          width: 2px;
          height: 100%;
          background: #000;
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
        }
      }
    }
  }

}

.p_pagenavi {
  &-btn {
    width: rem(60);
    height: rem(60);
    background: $palet1;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    z-index: 999;

    &:hover {
      @include pc {
        @include hover();
      }
    }

    .-arr {
      width: rem(18);
      height: rem(18);
      display: block;
      position: absolute;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &-prev {
      @include pc {
        left: rem(-60);
      }
      @include sp {
        left: rem(-20);
      }

      .-arr {
        transform: translateX(2px);
      }

      .prev {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        display: block;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff #fff transparent transparent;
      }
    }

    &-next {
      @include pc {
        right: rem(-60);
      }
      @include sp {
        right: rem(-20);
      }

      .-arr {
        transform: translateX(-2px);
      }

      .next {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        display: block;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff #fff transparent transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheModalOfTheGallery.vue